export enum EPostureType {
    DeboutBrasLeves = 1,
    DeboutBrasBas = 2,
    Assis = 3,
    Couche = 4,
    Accroupi = 5,
    AGenoux = 6,
}